import {SectionView} from './SectionView.ts'
import {type PIXI} from '@colonist/pixi'
import {type ViewAnimationController} from './ViewAnimationController.ts'
import {ViewAnimationControllerAdapter} from './animation/ViewAnimationControllerAdapter.ts'

export class MovingSectionView extends SectionView {
    readonly animationController: ViewAnimationController

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, removePadding: boolean = true) {
        super(x, y, w, h, container, removePadding)

        this.animationController = new ViewAnimationControllerAdapter(this)
    }
}
